import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: ${({ theme: { spacing } }): string => `${spacing()} ${spacing(1.5)}`};
  padding: ${({ theme: { spacing } }): string =>
    `${spacing(3)} ${spacing(2.5)}`};
  box-shadow: 0 0 6px ${({ theme }): string => theme.palette.border.shadow};
`;
